import React from 'react';
import { History } from 'history';
import store, { RouterStore } from '~/stores';
import { MobXProviderContext } from '~/utils/modules';

export const useStores = (): typeof store & {
  routing: History;
} => React.useContext(MobXProviderContext).rootStore;
